<template>
    <Dialog modal
            :closeOnEscape="true"
            :maximizable="false"
            :visible="isConfirmationOpen"
            :header="__(header)"
            v-model:visible="isConfirmationOpen"
            :style="modalStyle"
            :unstyled="false"
            class="delete-confirmation-modal"
            :class="modalClass"
            :pt="{
                header: {
                    class: headerClass,
                    style: headerStyle
                },
            }">
        <div :class="questionClass"
             :style="questionStyle">
            {{ __(question) }}
        </div>
        <div class="flex justify-end gap-2 mt-5 confirmation-actions">
            <Button :unstyled="true"
                    @click="executeOperation"
                    class="bg-white hover:bg-rose-50 text-rose-600 font-medium py-1 px-3 rounded-md border border-rose-200 hover:border-rose-300 transition-colors duration-150">
                {{ __('Yes') }}
            </Button>
            <Button :unstyled="true"
                    @click="closeConfirmationWindow"
                    :default="true"
                    class="bg-white hover:bg-gray-200 text-gray-600 font-medium py-1 px-3 rounded-md border border-gray-200 hover:border-gray-300 transition-colors duration-150">
                {{ __('No') }}
            </Button>
        </div>
    </Dialog>
</template>

<script setup>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { __ } from '@pages/Helper/utils.js'

const props = defineProps({
    operation: Function,
    cancel: {
        type: Function,
        required: false,
        default: null
    },
    parameter: {
        type: [Object, String],
        default: null
    },
    header: String,
    question: String,
    modalStyle: {
        type: Object,
        default: { width: '400px', borderColor: 'red' }

    },
    modalClass: {
        type: String,
        default: null
    },
    headerClass: {
        type: String,
        default: 'delete-confirmation-header'
    },
    headerStyle: {
        type: Object,
        default: null
    },
    questionClass: {
        type: String,
        default: 'delete-confirmation-field'
    },
    questionStyle: {
        type: Object,
        default: null
    }
});

const isConfirmationOpen = defineModel();

// --------------------------------------------------------------------------------

const executeOperation = () => {
    props.operation(props.parameter);
    closeConfirmationWindow();
};

// --------------------------------------------------------------------------------

const closeConfirmationWindow = () => {
    isConfirmationOpen.value = false
    if (props.cancel) {
        props.cancel(props.parameter);
    }
};

// --------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
